// src/components/user/shoppage/productcard/ProductCard.jsx

import React from 'react';
import { FaStar, FaStarHalfAlt, FaRegStar } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { Card, Button } from 'react-bootstrap';
import '../../../../assets/css/user/shoppage/productcard/ProductCard.css';

const ProductCard = ({ product, shopId, shopName, showShopName = false }) => {
  const navigate = useNavigate();

  const renderStars = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;

    for (let i = 0; i < fullStars; i++) {
      stars.push(<FaStar key={`full-${i}`} className="star-icon filled" />);
    }
    if (hasHalfStar) {
      stars.push(<FaStarHalfAlt key="half" className="star-icon filled" />);
    }
    const emptyStars = 5 - Math.ceil(rating);
    for (let i = 0; i < emptyStars; i++) {
      stars.push(<FaRegStar key={`empty-${i}`} className="star-icon" />);
    }
    return stars;
  };

  const goToProduct = () => {
    navigate(`/product/${product.id}`, { state: { shopId } });
  };

  const goToShop = (e) => {
    e.stopPropagation();
    navigate(`/shop/${shopId}`);
  };

  return (
    <Card className="product-card">
      <div className="product-image-wrapper">
        <Card.Img src={product.image} />

        {/* Availability Badge */}
        <span
          className={`availability-badge1 ${(product.availability || "available").toLowerCase()}`}
        >
          {product.availability || "Available"}
        </span>
      </div>

      <Card.Body>
        <h6 className="product-name">
          {product.name || product.equipmentname}
        </h6>

        <div className="product-rating">
          <div className="stars">{renderStars(product.rating || 0)}</div>
          <span className="reviews-count">({product.reviews || 0})</span>
        </div>

        <div className="product-price">
          <span className="price">
            {product.price
              ? `Rs. ${Number(product.price).toLocaleString('en-PK')} / ${product.priceUnit || "hour"}`
              : "Price on request"}
          </span>
        </div>


        {showShopName && (
          <p className="product-shop-name" onClick={goToShop}>
            {shopName}
          </p>
        )}

        <Button
          className="rent-now-btn"
          disabled={product.availability?.toLowerCase() === "rented"}
          onClick={(e) => {
            e.stopPropagation();
            goToProduct();
          }}
        >
          {product.availability?.toLowerCase() === "rented"
            ? "Rented"
            : "Rent Now"}
        </Button>
      </Card.Body>
    </Card>
  );
};

export default ProductCard;